export interface AppCoachResourcesSupplementsListFormRemove {
  id: string;
  organization_id: string;
  content: {
    name: string;
    description: string;
  };
}

export class AppCoachResourcesSupplementsListFormRemove implements AppCoachResourcesSupplementsListFormRemove {
  id: string;
  organization_id: string;
  content: {
    name: string;
    description: string;
  };

  constructor() {
    this.id = "";
    this.organization_id = "";
    this.content = {
      name: "",
      description: "",
    };
  }
}